/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sheet_CollapseInputs */

const en_ui_sheet_collapse = /** @type {(inputs: Ui_Sheet_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse panel`)
};

const de_ui_sheet_collapse = /** @type {(inputs: Ui_Sheet_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereich einklappen`)
};

/**
* | output |
* | --- |
* | "Collapse panel" |
*
* @param {Ui_Sheet_CollapseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sheet_collapse = /** @type {((inputs?: Ui_Sheet_CollapseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sheet_CollapseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sheet_collapse(inputs)
	return de_ui_sheet_collapse(inputs)
});